import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { StgRejectRequest } from '../../types/account'
import api from '../../api'

const useStgRejectAccount = (accountRequestID: string) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (payload: StgRejectRequest) => api.accounts.stgRejectAccount(payload),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['accounts'] })
			queryClient.invalidateQueries({ queryKey: ['accounts', accountRequestID] })
		}
	})
}

export default useStgRejectAccount
